// テスト環境の環境変数
export const devEnv = {
  production: false,
  apiHost: 'https://carzy-net.bambi.contact.co.jp',
  baseUrl: 'https://carzy-net.bambi.contact.co.jp',
  analyticsId: 'UA-95475-56',
  gaId: 'G-H1VC4MLRZG', // Google Analytics 4 ID
  googleAdsId: 'AW-1072208359',
  googleAdsTelConversion: 'AW-1072208359/77TdCPWP9NMBEOezov8D',
  googleTagManagerId: '',
  yahooYdnConvIo: 'zt6pbksOLDUjOZ6TmDPm',
  yahooYdnConvLabel: '9PJ0RRQSTKWO2YYU8PX719915',
  defaultLang: 'ja',
  facebookAppId: '2421447074532925',
  facebookAdsId: '',
};

// AWS開発環境の環境変数
export const sandboxEnv = {
  production: false,
  apiHost: 'https://carzy-net.work',
  baseUrl: 'https://carzy-net.work',
  analyticsId: 'UA-95475-56',
  gaId: 'G-H1VC4MLRZG', // Google Analytics 4 ID
  googleAdsId: 'AW-1072208359',
  googleAdsTelConversion: 'AW-1072208359/77TdCPWP9NMBEOezov8D',
  googleTagManagerId: '',
  yahooYdnConvIo: 'zt6pbksOLDUjOZ6TmDPm',
  yahooYdnConvLabel: '9PJ0RRQSTKWO2YYU8PX719915',
  defaultLang: 'ja',
  facebookAppId: '2421447074532925',
  facebookAdsId: '',
};

// AWS開発環境の環境変数
export const stgEnv = {
  production: false,
  apiHost: 'https://dev.carzy.net',
  baseUrl: 'https://dev.carzy.net',
  analyticsId: 'UA-95475-56',
  gaId: 'G-H1VC4MLRZG', // Google Analytics 4 ID
  googleAdsId: 'AW-1072208359',
  googleAdsTelConversion: 'AW-1072208359/77TdCPWP9NMBEOezov8D',
  googleTagManagerId: '',
  yahooYdnConvIo: 'zt6pbksOLDUjOZ6TmDPm',
  yahooYdnConvLabel: '9PJ0RRQSTKWO2YYU8PX719915',
  defaultLang: 'ja',
  facebookAppId: '2421447074532925',
  facebookAdsId: '',
};

// 本番環境の環境変数
export const prodEnv = {
  production: true,
  apiHost: 'https://www.carzy.net',
  baseUrl: 'https://www.carzy.net',
  analyticsId: 'UA-95475-41',
  gaId: 'G-QEJQYV58VD', // Google Analytics 4 ID
  googleAdsId: 'AW-1072208359',
  googleAdsTelConversion: 'AW-1072208359/77TdCPWP9NMBEOezov8D',
  googleTagManagerId: 'GTM-5BQRLHF',
  yahooYdnConvIo: 'zt6pbksOLDUjOZ6TmDPm',
  yahooYdnConvLabel: '9PJ0RRQSTKWO2YYU8PX719915',
  defaultLang: 'ja',
  facebookAppId: '2421447074532925',
  facebookAdsId: '378636173557410',
};
